export default "__VITE_ASSET__CgJTYa$x__"